import { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";

/*
  Section label sitting above a settings card, an onboarding step or a form field.
  Sentence case — the ALL-CAPS tracked-out treatment was removed in the violet
  rebrand (ADR 0003), as was the mono face, which is now reserved for numerals.
*/
export const Eyebrow: FC<{
  children: ReactNode;
  tone?: "muted" | "accent";
  className?: string;
}> = ({ children, tone = "muted", className }) => (
  <p
    className={cn(
      "text-meta font-medium",
      tone === "accent" ? "text-accent-text" : "text-text-3",
      className
    )}
  >
    {children}
  </p>
);

/* Field label above an input. Same voice as Eyebrow, without the bottom padding. */
export const FieldLabel: FC<{
  children: ReactNode;
  /** Id of the input this labels — without it the field has no accessible name. */
  htmlFor?: string;
  className?: string;
}> = ({ children, htmlFor, className }) => (
  <label htmlFor={htmlFor} className={cn("text-meta font-medium text-text-3", className)}>
    {children}
  </label>
);
